module.exports = __webpack_public_path__ + "media/images/lb/290-2daf92022b4f6a92466a034bf79d0c23.svg";